import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { feedback } from 'src/app/shared/constants';
import { environment } from 'src/environment';


@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor(private http: HttpClient) { }
  // this service call response to user feedback applicaton details.
  feedbackfun(data: object): Observable<any> {
    const feedbackUrl = environment.apiEndpoint + environment.version + feedback;
    return this.http.post(feedbackUrl, data).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response;
        }
      }, (error: HttpErrorResponse) => {
        console.log(error);
      })
    );
  }

}
